/*
  So when form is filled and submit, tracking module init is called
  init:
- add loading class to results
  - await calls
    - getSKUList: fetch skulist from collection url json and save to this.SKUList
    - getDEARDetails: fetch order details from DEAR save to this.data
    - getOrderDetails: fetch order details from shopify save to this.carrier, this.trackingURL, this.trackingNumber
  - if calls are successful
    - setStatus: set this.currentStage and this.deliveryTime
    - renderStatus: render this.currentStage and this.deliveryTime
    - renderLineItems: render line items
    - renderTrackingInformation: render carrier, trackingURL, trackingNumber
    - remove loading class from results


logic
  1) Order received - default
  2) Order being produced - order state = BACKORDERED only with promise date between 99 weeks and 5 weeks
  3) Quality control - order state = BACKORDERED with promise date between 0 weeks and 5 weeks
  4. Items in warehouse - order state = ORDERED (Item in stock)
  5. Order being prepared - order state = PICKED
  6. Dispatched - order state = COMPLETED

  Order cancelled - order state is VOID or CREDITED
*/
class TrackingModule extends HTMLElement {
  constructor() {
    super();
    this.instock_shipping_days = window.theme_settings.instock_shipping_days;
    this.elements = {
      form: document.getElementById("track-order-form"),
      status_bar: document.getElementById("status-timeline"),
      results: document.querySelector(".result-wrap"),
      time_label: document.getElementById("delivery-time"),
      line_items_container: document.querySelector(".track-order-line-items"),
      trackingData: document.querySelector("[tracking-data]"),
      APIerror: document.getElementById("api-error"),
      dearError: document.getElementById("dear-error"),
    };
  }

  async init() {
    this.elements.results.classList.add("loading");

    try {
      this.SKUList = await this.getSKUList();
      Object.assign(this, await this.getOrderTrackingDetails());
    } catch (error) {
      console.error("Error fetching order details:", error);
      this.showError('api');
      return;
    }

    if(this.currentStage === "unknown") {
      this.notFulfilled();
      this.showError('dear');
      return;
    }

    this.renderStatus();
    this.renderLineItems();
    this.renderTrackingInformation();
    this.elements.results.classList.add("loaded");
  }

  async getSKUList() {
    try {
      const response = await fetch("/collections/data?view=skulist");
      if (!response.ok) {
        throw new Error(`${response.status} - ${response.statusText}`);
      }
      return await response.json();
    } catch (error) {
      if (error instanceof SyntaxError) {
        console.error("Invalid JSON", error);
      } else {
        console.error("Error fetching SKU list", error);
      }
      return null;
    }
  }

  async getOrderTrackingDetails() {
    const url = "https://proxy-ii-iota.vercel.app/api/order-tracking-details";
    const body = {
      host: Shopify.shop,
      email: this.dataset.email,
      orderName: this.dataset.orderName,
      leadtime_string: window.theme_settings.leadtime_string,
      instock_shipping_days: this.instock_shipping_days,
    };

    const response = await fetch(url, {
      method: "POST",
      mode: "cors",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error("No data received from Shopify", { cause: "500-e003" });
    }

    const data = await response.json();
    console.log(data)

    if (!data) {
      throw new Error("No data received from Shopify", { cause: "500-e003" });
    }

    return data;
  }

  notFulfilled() {
    this.fulfilled = false;
    this.elements.trackingData.innerHTML = "";
  }

  showError(type) {
    if (type === "dear") {
      this.elements.dearError.classList.remove("opacity-0");
    } else {
      this.elements.APIerror.classList.remove("opacity-0");
    }
    this.elements.results.classList.remove("loading");
    this.elements.trackingData.innerHTML = "";
  }

  renderStatus() {
    this.elements.time_label.innerHTML = this.deliveryTime;
    this.elements.status_bar.dataset.stage = this.currentStage;
    this.elements.results.classList.replace("loading", "loaded");
  }

  renderTrackingInformation() {
    let trackingHTML = `
      <h2>${this.fulfilled ? 'Shipping Information' : 'Order Status'}:</h2>
      <p>${this.displayMessageHTML ? this.displayMessageHTML : this.displayMessage}</p>
    `
    this.elements.trackingData.innerHTML = trackingHTML;
  }

  renderLineItems() {
    // burada problem var, isim garip geliyor, skulistten cektigimiz isim lazim.
    // ve tabi unfulfilled, api sicmasi gibi durumlari backuplamamiz gerekiyor.
    const lineItemsHTML = this.line_items.reduce((acc, item) => {
      if (item.Comment == "BOM component") {
        return acc;
      }

      if (item.SKU == "ExpandedBOM") {
        var itemDetails = item.Comment.split(":");
        var itemSKU = itemDetails[0];
        var itemName = itemDetails[1];
        acc += `<div class="track-order-item">
            <div class="text">
              <p class="mb2">${item.Quantity} x ${itemName}</p>
              <span class="meta">SKU ${itemSKU}</span>
            </div>
          </div>`;
        return acc;
      } else {
        acc += `<div class="track-order-item">
            <div class="text">
              <p class="mb2">${item.Quantity} x ${
          this.SKUList[item.SKU] || item.Name
        }</p>
              <span class="meta">SKU ${item.SKU}</span>
            </div>
          </div>`;
        return acc;
      }
    }, "");

    this.elements.line_items_container.innerHTML = lineItemsHTML;
  }
}

customElements.define("tracking-module", TrackingModule);

class TrackingForm extends HTMLElement {
  constructor() {
    super();
    this.trackingModule = document.querySelector("tracking-module");
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('[type="submit"]');
    this.elements = {
      APIerror: document.getElementById("api-error"),
      dearError: document.getElementById("dear-error"),
    };
  }

  connectedCallback() {
    this.form.addEventListener("submit", this.onSubmit.bind(this));
    this.autoSubmit();
  }

  onSubmit(e) {
    e.preventDefault();
    this.setDataOnTrackingModule();
  }

  autoSubmit() {
    // if url has email and order no parameters, autofill and submit
    const params = new URLSearchParams(window.location.search);

    if ([...params.values()].length === 0) return false;

    params.forEach((x, y) => {
      if (!document.getElementById(y)) {
        return;
      }
      document.getElementById(y).value = x;
    });

    this.submitButton.click();
  }

  setDataOnTrackingModule() {
    const email = [...this.form.elements]
      .find((element) => element.type === "email")
      .value.trim();
    const orderName = [...this.form.elements]
      .find((element) => element.type === "text")
      .value.trim()
      .toUpperCase();

    this.trackingModule.dataset.email = email;
    this.trackingModule.dataset.orderName = orderName;

    // update url
    const params = new URLSearchParams(window.location.search);
    params.set("track-order-email", email);
    params.set("track-order-input", orderName);
    window.history.replaceState({}, "", `${location.pathname}?${params}`);
    this.hideError();

    this.trackingModule.init();
  }
  hideError() {
    this.elements.dearError.classList.add("opacity-0");
    this.elements.APIerror.classList.add("opacity-0");
  }
}

customElements.define("tracking-form", TrackingForm);
